// src/App.jsx
import React from "react";
import { RouterProvider } from "react-router";
import { ThemeProvider } from "./context/ThemeContext.jsx";
import { AuthProvider } from "./context/AuthContext.jsx";
import { LocationProvider } from './context/LocationContext';
import { router } from "./routes.config";
import GlobalErrorBoundary from "./components/ui/boundaries/globalErrorBoundary.jsx";

function App() {
  return (

    <ThemeProvider>
      <AuthProvider>
        <LocationProvider>
          <GlobalErrorBoundary>
            <RouterProvider router={router} />
          </GlobalErrorBoundary>
        </LocationProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
